import { useApiCall } from '@efexteam/use-api-call';
import BENEFICIARY_SVC from '../services/getBeneficiary';
import {
  UpdateBeneficiaryServiceRequest,
  UseApproveBeneficiaryReturn,
} from '../types';

const useApproveBeneficiary = (): UseApproveBeneficiaryReturn => {
  const {
    data,
    invoke: updateBeneficiary,
    loading,
    error,
  } = useApiCall((args?: UpdateBeneficiaryServiceRequest) => {
    if (!args?.token || !args?.action) {
      return Promise.reject(new Error('Token and action are required'));
    }
    return BENEFICIARY_SVC.updateBeneficiary({
      token: args.token,
      action: args.action,
    });
  });

  return { data, updateBeneficiary, loading, error };
};

export default useApproveBeneficiary;
